import { render, staticRenderFns } from "./MmData.vue?vue&type=template&id=5f1b27f5&scoped=true&"
import script from "./MmData.vue?vue&type=script&lang=js&"
export * from "./MmData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1b27f5",
  null
  
)

export default component.exports